import React from 'react';
import ReferralsPage from './ReferralsPage';

export default function EmployerReferrals() {
  return <ReferralsPage title="Employer Referrals" userType="employer" />;
}
